import { render, staticRenderFns } from "./Personpayroll.vue?vue&type=template&id=1d883886&scoped=true&"
import script from "./Personpayroll.vue?vue&type=script&lang=js&"
export * from "./Personpayroll.vue?vue&type=script&lang=js&"
import style0 from "./Personpayroll.vue?vue&type=style&index=0&id=1d883886&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d883886",
  null
  
)

export default component.exports